import type { ReactNode } from 'react';

/**
 * Standard body of every OS window: title row (28px condensed heading, grey subtitle, right-aligned actions)
 * followed by a 32px-padded content column. Replaces @os/ui's `PageHeader`, whose 64px bar and mobile menu
 * button belong to the classic sidebar shell, not to a desktop window.
 */
export function Page({ title, subtitle, actions, children }: { title: string; subtitle?: ReactNode; actions?: ReactNode; children: ReactNode }) {
  return (
    <div className="pg">
      <header className="pg-head">
        <div style={{ minWidth: 0 }}>
          <h1>{title}</h1>
          {subtitle && <p className="pg-sub">{subtitle}</p>}
        </div>
        {actions && <div className="pg-actions">{actions}</div>}
      </header>
      <div className="pg-body">{children}</div>
    </div>
  );
}

/** Inline error banner for a failed query; renders nothing when there is no error. */
export function PageAlert({ error, fallback }: { error: unknown; fallback: string }) {
  if (!error) return null;
  return <div className="pg-alert" role="alert">{error instanceof Error ? error.message : fallback}</div>;
}

/** Small centred placeholder inside a table or list. */
export function PageEmpty({ children }: { children: ReactNode }) {
  return <div className="pg-empty">{children}</div>;
}
